/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_DescriptionInputs */

const en_admin_permissions_description = /** @type {(inputs: Admin_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage system permissions`)
};

/**
* | output |
* | --- |
* | "Manage system permissions" |
*
* @param {Admin_Permissions_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_permissions_description = /** @type {((inputs?: Admin_Permissions_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_permissions_description(inputs)
});
export { admin_permissions_description as "admin.permissions.description" }